module.exports = __webpack_public_path__ + "img/pumping-activities-title.3999b760.png";